import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'

import { airForceBlue, white } from '../../constants/principles'
import { BrowserUtils, StringUtils } from '../../utils/siteUtils'
import { FlexDiv, BodyDivFlex } from '../generic/Basics'
import Survey from '../generic/Survey'
import LegalText from '../landing/LegalText'
import CertificateHeader from './CertificateHeader'
import Offer from './Offer'
import NextSteps from './NextSteps'
import LegalTextDealerBoost from '../landing/LegalTextDealerBoost'
import CertificateComponentWrapper from './CertificateComponentWrapper'
import InprogressOffer from './InprogressOffer'

// isInitialCertificateViewing implies that we just submitted the offer. see logic in useprospectoffer hook
export default ({
  year,
  make,
  model,
  trim,
  images,
  setShowModal,
  offer,
  isInitialCertificateViewing,
  offerError,
  addImpressions,
  updateGlobalState,
  urlState,
  globalState: { environment, certificatePageIsLoaded, isOutageError, prospectId },
  experienceState: {
    displayImages,
    isCobrand,
    isCombinedOffer,
    isDigitalRetail,
    isAssigned,
    isAdmin,
    dealerName,
    isCobrandDR,
    dealerGroups,
    dealerGuid,
    dealerIsDirectToKBB,
    dealerIsDirectToKBBv2,
    offerCode,
    isUIForWC,
    isShowCustomerDealerList,
    prospectResult
  },
  autoCheckData,
  qxData,
  offerEditedEmailToggle,
  location,
  ...props
}) => {
  const [showSurvey, setShowSurvey] = useState(false)
  const [fcaPosted, setFcaPosted] = useState(false)
  const [openReqAppOverlay, setOpenReqAppOverlay] = useState(false)
  const [disableRequestBtn, setDisableRequestBtn] = useState(false)
  const [reqAppDealer, setReqAppDealer] = useState(undefined)
  const [appointmentDate, setAppointmentDate] = useState(undefined)
  const isDesktop = BrowserUtils.isDesktop()
  const runUntilDate = new Date('Jan 8 2020')
  const stepType = offer && offer.status === 'INELIGIBLE' ? 'trade-in' : offer && offer.status === 'FR' ? 'none' : 'dealer'
  /*
    isDrOffer && isCobrandOffer are assigned from offer object because
    isDigitalRetail && isCobrand only have value if query params are present
  */
  const isDrOffer = offer && (offer.offerCode === 'D' || isDigitalRetail)
  const isCobrandOffer = offer && (offer.offerCode === 'WC' || offer.offerCode === 'OC' || offer.offerCode === 'TC' || isCobrand) && !isCobrandDR
  const isUnassignedOnly = !isAssigned && !isDrOffer && !isCobrandOffer && !isCobrandDR && !isCombinedOffer
  const isAssignedOnly = isAssigned && !isDrOffer && !isCobrandOffer && !isCobrandDR && !isCombinedOffer
  const certificateWebComponentIsEnabledForCurrentEnv = environment.funnelWebComponentUrl
  const expired = offer && (offer.status === 'EXPIRED' || offer.isExpired)
  const displaySurvey = offer && offer.status === 'CLEARED' && isInitialCertificateViewing && !isAdmin && !isAssigned && !isCobrand && !isCombinedOffer && !isDigitalRetail && (!runUntilDate || new Date() < runUntilDate)
  const makemodel = offer && offer.prospect && offer.prospect.replacementVehicle && offer.prospect.replacementVehicle.find(q => q.questionId === 'qrv/MakeAndModel').subquestions
  const error = offerError
  const reserveOffer = offer && offer.isExclusiveOffer
  const surveyAnswers = [
    { id: '1', text: 'Extremely' },
    { id: '2', text: 'Very' },
    { id: '3', text: 'Moderately' },
    { id: '4', text: 'Slightly' },
    { id: '5', text: 'Not at All' }
  ]
  let isHasMarkup = isAssigned && dealerGuid && offer?.markupAmounts && offer?.markupAmounts[dealerGuid] !== undefined && offer?.markupAmounts[dealerGuid] > 0
  environment = environment || {}
  year = year || { displayName: '..' }
  make = make || { displayName: '..' }
  model = model || { displayName: '..' }

  if (isCombinedOffer)
    setTimeout(() => {
      BrowserUtils.resizeParent('icoCertificate')
    }, 1000)

  useEffect(() => {
    if (certificateWebComponentIsEnabledForCurrentEnv) {
      BrowserUtils.addScript(environment.funnelWebComponentUrl + '?' + Math.floor(Math.random() * 9999), document.head, 'module', false)
    }

    setTimeout(() => setShowSurvey(true), 3000)
    setCertPageLoaded()
  }, [])

  // useEffect(() => {
  //   if (offer && offer.offerId && dealerGroups && dealerGroups.includes('FCA') && !fcaPosted) {
  //     BrowserUtils.postOfferFca(offer, year, make, model, makemodel)
  //     setFcaPosted(true)
  //   }
  // }, [offer, dealerGroups, make, makemodel, model, year, fcaPosted])

  useEffect(() => {
    if (offer) {
      offer.prospect.dealershipsAndInventory.allocationEntries.forEach(({ dealerInfo: dealer }, idx) => {
        const phoneString = dealer.dealershipPhone ? StringUtils.formatPhoneString(dealer.dealershipPhone) : dealer.dealershipPhone
        const phoneTag = phoneString && phoneString.replace(/[\W]/g, '')
        const dealerTag = dealer.dealershipName && dealer.dealershipName.slice(0, 50).replace(/[\W]/g, '')
        if (idx === offer?.prospect.dealershipsAndInventory.allocationEntries.length - 1) {
          updateGlobalState({ fireAnalytics: `${dealerTag}_${phoneTag}_lnk` })
        } else {
          addImpressions(`${dealerTag}_${phoneTag}_lnk`)
        }
      })
    }
  }, offer && offer.prospect.dealershipsAndInventory.allocationEntries)

  const shouldShowOfferCertificateWebComponent = () => {
    if (certificateWebComponentIsEnabledForCurrentEnv && (isCobrandDR || isUnassignedOnly || isDrOffer || isAssignedOnly || isCobrandOffer)) {
      return true
    } else {
      return false
    }
  }

  const setCertPageLoaded = () => {
    updateGlobalState({ certificatePageIsLoaded: true })
  }

  const shouldShowNextStepsOnV1 = !expired && !isDigitalRetail && !isAdmin && !isCobrandDR && stepType && stepType !== 'none'
  const shouldShowNextStepsOnV2 = shouldShowNextStepsOnV1 && offer?.status !== 'INELIGIBLE'
  const shouldShowNextSteps = dealerIsDirectToKBBv2 ? shouldShowNextStepsOnV2 : shouldShowNextStepsOnV1
  const { initialPathParams, initialQueryParams } = BrowserUtils.getInitParams()
  const utmSource = initialQueryParams.utm_source ? initialQueryParams.utm_source : ''
  const canEditMileageIneligible = initialQueryParams && initialQueryParams.caneditmileageineligible ? initialQueryParams.caneditmileageineligible : false
  const minimumMileageIneligibleThreshold = initialQueryParams && initialQueryParams.minimummileageineligiblethreshold ? initialQueryParams.minimummileageineligiblethreshold : 0
  const initUrlState = StringUtils.getUrlState(location) || {}
  const prospectIdParam = initUrlState.pa && initUrlState.pa[0] && initUrlState.pa[0].indexOf('prospect') === 0 && initUrlState.pa[1]
  const offerId = offer?.offerId
  const prospectGuid = prospectIdParam || prospectId
  return shouldShowOfferCertificateWebComponent() ? (
    <CertificateComponentWrapper
      certificatePageIsLoaded={certificatePageIsLoaded}
      updateGlobalState={updateGlobalState}
      offerId={offerId}
      utmSource={utmSource}
      isAdmin={isAdmin}
      offerCode={offerCode}
      urlState={urlState}
      offer={offer}
      nextClick={props.nextClick}
      updateVehiclePropNumber={props.updateVehiclePropNumber}
      canEditMileageIneligible={canEditMileageIneligible}
      minimumMileageIneligibleThreshold={minimumMileageIneligibleThreshold}
      qxData={qxData}
      prospectId={!prospectGuid ? '' : prospectGuid}
      dealerName={dealerName}
      dealerIsDirectToKBB={dealerIsDirectToKBB}
    />
  ) : isOutageError || prospectIdParam ? (
    <InprogressOffer
      setShowModal={setShowModal}
      updateGlobalState={updateGlobalState}
      dealerIsDirectToKBBv2={dealerIsDirectToKBBv2}
      year={year}
      make={make}
      model={model}
      trim={trim}
      isAdmin={isAdmin}
      prospectId={prospectId}
      prospectResult={prospectResult}
      urlState={environment.kbb_Url}
    />
  ) : offer && !error ? (
    <>
      <BodyDivFlex>
        <CertificateHeader setShowModal={setShowModal} updateGlobalState={updateGlobalState} dealerIsDirectToKBBv2={dealerIsDirectToKBBv2} />
        <Offer
          {...{
            year,
            make,
            model,
            trim,
            images,
            offer,
            isDesktop,
            setShowModal,
            isAdmin,
            canResubmit: offer.canBeResubmitted,
            displayImages,
            isAssigned,
            isDigitalRetail,
            dealerName,
            isCobrandDR,
            autoCheckData,
            qxData,
            setOpenReqAppOverlay,
            disableRequestBtn,
            appointmentDate,
            dealerGuid,
            isCombinedOffer,
            updateGlobalState,
            dealerIsDirectToKBB,
            dealerIsDirectToKBBv2,
            offerCode,
            isUIForWC,
            isShowCustomerDealerList
          }}
          {...props}
        />
        {shouldShowNextSteps && isShowCustomerDealerList && (
          <NextSteps
            {...{
              stepType,
              isDesktop,
              year,
              make,
              model,
              trim,
              isCobrand,
              isAssigned,
              dealers: offer.prospect.dealershipsAndInventory,
              appointments: offer.appointments,
              replacementVehicle: offer.prospect.replacementVehicle,
              offerId: offer.offerId,
              kbbUrl: environment.kbb_Url,
              atcUrl: environment.atc_Url,
              dealerName,
              updateGlobalState,
              isAppointmentRequestEnabled: offer.isAppointmentRequestEnabled,
              addImpressions,
              reserveOffer,
              dealerIsDirectToKBB,
              dealerIsDirectToKBBv2,
              offerEditedEmailToggle
            }}
          />
        )}
        <LegalText dealerIsDirectToKBBv2={dealerIsDirectToKBBv2} kbbUrl={environment.kbb_Url} />
        {!expired && isHasMarkup && <LegalTextDealerBoost kbbUrl={environment.kbb_Url} />}
      </BodyDivFlex>
      {displaySurvey && (
        <StickyBottomDiv showSurvey={showSurvey}>
          <Survey
            questionSubheader={'How happy are you with the Offer amount?'}
            showClose={true}
            updateGlobalState={updateGlobalState}
            answers={surveyAnswers}
            onClickAnswer={() => setShowSurvey(false)}
            onClickClose={() => setShowSurvey(false)}
            addImpressions={addImpressions}
            surveyKey={'icosurvey_cert'}
            backgroundColor={airForceBlue}
            fontColor={white}
          />
        </StickyBottomDiv>
      )}
    </>
  ) : !error ? (
    ''
  ) : (
    <FlexDiv>Error {offerError}</FlexDiv>
  )
}

const StickyBottomDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: ${p => (p.showSurvey ? 0 : -1000)}px;
  transition: all 1s;
  z-index: 20;
`

const LoadingDiv = styled.div`
  padding-top: 100px;
  display: ${p => (p.componentIsLoaded ? 'none' : 'flex')};
  justify-content: center;
  height: 100vh;
`
